import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPagerdutyComponent } from './simple-icons-pagerduty.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPagerdutyComponent ],
    exports:      [ SimpleIconsPagerdutyComponent ],
    bootstrap:    []
})
export class SimpleIconsPagerdutyModule {}
